import React from 'react';
import { Link } from 'react-router-dom';
import { CookbookCategoryTag, cloudflareImage } from '@front-activerse/common-components';

import { useOutletContext } from 'react-router-dom';
import { useAppContext } from '@front-activerse/common-components';

const CookbookRecipeTypeItem: React.FC<CookbookCategoryTag> = ({
  id,
  imageUrl,
  name,
  mealsCount,
}) => {
  const { trackFirebaseEvent } = useOutletContext<{
    trackFirebaseEvent: (eventName: string, eventPayload: object) => void;
  }>();

  const {
    consts: { APP_BRAND },
  } = useAppContext();

  const coverImage = cloudflareImage(imageUrl, `${APP_BRAND}`, 'cookbookRecipeTypeItem');

  return (
    <div className="cookbook-recipe-type-item">
      <Link
        to={`/meals/cookbook/tag/${id}`}
        onClick={() => {
          trackFirebaseEvent('user_action', {
            action: 'tap-diet_type',
            location: 'Dietplan',
            meals_tab: 'cookbook',
            selectedDiet: id,
          });
        }}
      >
        <img src={coverImage} className="img-fluid" alt={name} />
        <h2 className="title-medium semi-bold">{name}</h2>
      </Link>
    </div>
  );
};

export default CookbookRecipeTypeItem;
